"use strict";exports.__esModule=true;exports.default=void 0;function formatTrim(str){var n=str.length,i=1,i0=-1,i1;for(;i<n;++i){if(str[i]==="."){i0=i1=i}else if(str[i]==="0"){if(i0===0)i0=i;i1=i}else{if(i0>0){if(!+str[i])break;i0=0}}}return i0>0?str.slice(0,i0)+str.slice(i1+1):str}var _default=formatTrim;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/number-converter/format-trim.js
// module id = HVH/
// module chunks = 5